import { capitalize, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { getMediaUrl } from '@onesource/services';
import { formatDurationLabel } from '@onesource/utils';
import { MdAccessTime, MdPlayCircle } from 'react-icons/md';

import { ContentCategoryBadge } from '#/features/community-hub/components/content-category-badge';

import type { CardProps } from './types';

export const VideoCard = ({ block, onClick }: CardProps) => {
  const theme = useTheme();

  return (
    <Box
      onClick={onClick}
      sx={{
        width: 288,
        bgcolor: 'white',
        borderRadius: '15px',
        overflow: 'hidden',
        boxShadow: '0px 5px 10px rgba(0,0,0,0.04)',
        flexShrink: 0,
        cursor: 'pointer',
        transition: 'all 0.2s',
        '&:hover': {
          boxShadow: '0px 8px 16px rgba(0,0,0,0.05)',
          transform: 'translateY(-2px)',
        },
      }}
    >
      <Box sx={{ p: 1.5 }}>
        <Box
          sx={{
            height: 149,
            bgcolor: 'grey.300',
            borderRadius: '13px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          {block.vimeoThumbnailUrl && getMediaUrl(block.vimeoThumbnailUrl) ? (
            <Box
              component="img"
              src={getMediaUrl(block.vimeoThumbnailUrl)}
              alt={block.title || 'Video'}
              sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          ) : (
            <MdPlayCircle size={48} color="#666" />
          )}
          <Box
            sx={{
              position: 'absolute',
              bottom: 8,
              right: 8,
              bgcolor: 'rgba(0,0,0,0.7)',
              px: 1,
              py: 0.25,
              borderRadius: 1,
            }}
          >
            <Typography variant="caption" sx={{ color: 'white', fontSize: '11px' }}>
              {formatDurationLabel(block.vimeoDurationSeconds)}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ px: 2, pb: 2 }}>
        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#333', mb: 0.5 }}>
          {block.title || 'Untitled Video'}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          {block.contentCategory && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <ContentCategoryBadge size="medium" color="primary" category={block.contentCategory} />
              <Typography variant="caption" sx={{ color: theme.palette.grey[600], fontSize: '9px' }}>
                {capitalize(block.contentCategory.toLowerCase())}
              </Typography>
            </Box>
          )}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <MdAccessTime size={15} color={theme.palette.primary.main} />
            <Typography variant="caption" sx={{ color: theme.palette.grey[600], fontSize: '9px' }}>
              {formatDurationLabel(block.vimeoDurationSeconds)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
